/* global angular */
angular.module('ua5App').
    filter('toSlug', [function() {
        return function(value) {
            return value.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-');
        };
    }])
;
